<template>
  <PVBadge
    :data-testid="dataTestid"
    :value="value"
    :severity="severity"
    :size="size"
  >
    <!--
      Conditional #default so PVBadge does not receive an empty slot. Always wrapping
      <slot /> makes PrimeVue treat content as provided and skip its {{ value }} fallback.
    -->
    <template
      v-if="hasDefaultSlotContent"
      #default
    >
      <slot />
    </template>
  </PVBadge>
</template>

<script lang="ts">
export default {
  name: 'StandardBadge',
  compatConfig: { MODE: 3 },
};
</script>

<script setup lang="ts">
import { computed, useSlots } from 'vue';
import type { BadgeProps } from 'primevue/badge';
import { hasRenderedSlotContent } from '@/utils/vueSlots';

defineProps<{
  /**
   * Value to display inside the badge. Omit (and leave the default slot empty) for a dot badge.
   */
  value?: BadgeProps['value'];
  /**
   * Visual style from the active design-token preset.
   * Omit for primary (default).
   */
  severity?: BadgeProps['severity'];
  /**
   * Badge size from the design system: `small`, `large`, or `xlarge`.
   * Omit for the default (medium) size.
   */
  size?: BadgeProps['size'];
  dataTestid?: string;
}>();

const slots = useSlots();

const hasDefaultSlotContent = computed((): boolean => slots.default != null && hasRenderedSlotContent(slots.default()));
</script>
